module.exports = __webpack_public_path__ + "static/media/java.e7868999.png";